<template>
  <section data-aos="fade" class="bg-purple-50 relative">
    <div class="relative isolate">
      <div class="mx-auto max-w-7xl sm:px-6 lg:px-8">
        <img
          data-aos="fade-down"
          class="w-32 mx-auto relative h-auto lg:w-64 lg:absolute"
          :src="Mockup"
          alt="mockup prototype"
          height="237"
          width="128"
          loading="lazy"
        />
        <div
          class="mx-auto flex max-w-2xl flex-col gap-16 bg-white/5 px-6 py-16 ring-1 ring-white/10 sm:rounded-3xl sm:px-8 sm:py-24 lg:mx-0 lg:max-w-none lg:grid lg:grid-cols-3 lg:items-center lg:py-32 xl:gap-x-20 xl:px-20"
        >
          <div
            data-aos="fade-up"
            class="w-full flex-auto col-span-2 col-start-2"
          >
            <h2
              class="text-4xl font-semibold tracking-tight text-pretty text-gray-800 sm:text-5xl"
            >
              Built for teachers. Backed by schools.
            </h2>
            <p class="mt-6 text-lg/8 text-pretty text-gray-600">
              Designed with real classrooms in mind – simple, secure and
              school-approved.
            </p>
            <ul
              role="list"
              class="mt-10 grid grid-cols-1 gap-x-8 gap-y-3 text-base/7 text-gray-600"
            >
              <li v-for="item in list" :key="item.id">
                <i class="text-purple-600 fa-solid fa-check-circle me-2"></i>
                {{ item.body }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="absolute inset-x-0 -top-16 -z-10 flex transform-gpu justify-center overflow-hidden blur-3xl"
        aria-hidden="true"
      >
        <div
          class="aspect-1318/752 w-329.5 flex-none bg-linear-to-r from-purple-100 to-purple-400 opacity-25"
          style="
            clip-path: polygon(
              73.6% 51.7%,
              91.7% 11.8%,
              100% 46.4%,
              97.4% 82.2%,
              92.5% 84.9%,
              75.7% 64%,
              55.3% 47.5%,
              46.5% 49.4%,
              45% 62.9%,
              50.3% 87.2%,
              21.3% 64.1%,
              0.1% 100%,
              5.4% 51.1%,
              21.4% 63.9%,
              58.9% 0.2%,
              73.6% 51.7%
            );
          "
        ></div>
      </div>
    </div>
    <i
      class="fa-solid fa-lock text-9xl opacity-5 absolute right-1/4 bottom-0 rotate-12 text-purple-600 lg:text-[300px]"
    ></i>
  </section>
</template>
<script setup lang="ts">
import Mockup from "/mockups/4.webp";

const list = [
  {
    id: 1,
    body: "No distractions. No ads.",
    icon: "fas fa-comment-dots",
  },
  {
    id: 2,
    body: "Privacy-first, always",
    icon: "fas fa-newspaper",
  },
  {
    id: 3,
    body: "Made by educators, for educators",
    icon: "fas fa-newspaper",
  },
  {
    id: 4,
    body: "Fits your day, not the other way around",
    icon: "fas fa-newspaper",
  },
];
</script>
